import { PLAYER_SHARES_URL } from '@/configs';
import { ISSUE_SHARES_URL } from '@/constants/common';
import { ROUTE_PATH } from '@/constants/route-path';
import withAlphaMiddleware from '@/hocs/withAlphaMiddleware';
import IssueForm from '@/modules/AlphaPWA/PlayerShares/issueForm';
import { useAppDispatch } from '@/state/hooks';
import { openModal } from '@/state/modal';
import { isProduction } from '@/utils/commons';
import { Box, Flex, Text } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import { useEffect, useMemo, useState } from 'react';
import s from './PlayerShares.module.scss';
import { getUrlToSwap } from '@/utils/helpers';

const ALPHA_NBC_URL = `https://alpha.${
  isProduction() ? '' : 'dev.'
}newbitcoincity.com`;

export const ISSUE_KEY_MODAL = 'ISSUE_KEY_MODAL';

const JackpotPlayerShares = () => {
  const router = useRouter();
  const { address, view } = router.query as {
    address: string;
    view?: 'buy' | 'issue' | 'holding' | 'holders';
  };
  const [hydration, setHydration] = useState(false);
  const dispatch = useAppDispatch();

  const url = useMemo(() => {
    if (!address)
      return view === 'issue' ? ISSUE_SHARES_URL : PLAYER_SHARES_URL;

    switch (view) {
      case 'buy':
        return `${ALPHA_NBC_URL}/alpha-keys/trade/${address}`;

      case 'holding':
        return `${ALPHA_NBC_URL}/alpha-keys/portfolio/${address}`;

      case 'holders':
        return `${ALPHA_NBC_URL}/alpha-keys/shares-detail/${address}`;

      default:
        break;
    }
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setHydration(true);
    }
  }, []);

  useEffect(() => {
    if (hydration && window) {
      window.onmessage = function (event: any) {
        try {
          const eventData = JSON.parse(event.data);
          console.log(':rocket: ~ useEffect ~ eventData:', eventData);
          switch (eventData.name) {
            case 'goto_profile':
              router.push(
                `${ROUTE_PATH.ALPHA_MOBILE_PROFILE}/${eventData.address}`
              );
              break;
            case 'goto_trade_pro':
              router.push(`${ROUTE_PATH.ALPHA_TRADE_PRO}`);
              break;
            case 'goto_trade':
              // router.push(
              //   `${ROUTE_PATH.ALPHA_TRADE}?address=${eventData.address}`
              // );

              router.push(getUrlToSwap(eventData?.address));
              break;
            default:
              break;
          }
        } catch (error) {}
      };
    }
  }, [hydration]);

  // const url = useMemo(() => {
  //   if (buy && address) {
  //     return `https://alpha.${isProduction() ? '' : 'dev.'}newbitcoincity.com/alpha-keys/trade/${address}`;
  //   }

  //   return address
  //     ? `https://alpha.${isProduction() ? '' : 'dev.'}newbitcoincity.com/alpha-keys/trade/${address}`
  //     : issue
  //     ? ISSUE_SHARES_URL
  //     : PLAYER_SHARES_URL;
  // }, [address]);

  const showCreatePostModal = () => {
    dispatch(
      openModal({
        id: ISSUE_KEY_MODAL,
        theme: 'dark',
        // title: `Pre-sale`,
        className: s.modalContent,
        modalProps: {
          centered: true,
          zIndex: 9999999,
        },
        render: () => <IssueForm />,
      })
    );
  };
  return (
    <Box h={'100%'}>
      <Flex
        className={s.notify}
        bg={'#DBF2FF'}
        h={'28px'}
        justifyContent={'center'}
        alignItems={'center'}
        onClick={showCreatePostModal}
      >
        <Text fontSize={'12px'} fontWeight={400} color={'#4C9EEB'}>
          Can’t find your favorite influencer? Issue their placeholder keys.
        </Text>
      </Flex>
      <iframe
        src={`${url}?header=true`}
        width="100%"
        height="max-content"
        className={s.iframe}
        id={'keys_iframe'}
      />
    </Box>
  );
};

export default withAlphaMiddleware(JackpotPlayerShares);
